import React, { useState } from 'react';
import { Button } from 'antd';

import { WalletTransactionDetailsProps } from 'types/wallet';
import { Modal } from 'components/components';
import AIWalletModalContent from './components/AIWalletModalContent';

const AIWalletTransactionDetailsModal = (props: WalletTransactionDetailsProps) => {
  const [isDetailsModalOpen, setIsDetailsModalOpen] = useState<boolean>(false);

  const toggleModal = () => {
    setIsDetailsModalOpen(!isDetailsModalOpen);
  }

  return (
    <>
      <Button onClick={toggleModal} className="secondary-button">View Details</Button>
      <Modal
        title="Transactions Details"
        footer={null}
        open={isDetailsModalOpen}
        onCancel={toggleModal}
        isEditButton={false}
      >
        <AIWalletModalContent transaction={props.transaction} />
      </Modal>
    </>
  )
}

export default AIWalletTransactionDetailsModal;
